import React from 'react';
import { useTranslation } from '../../i18n';

type PlayerRow = { id: string; name: string; score: number };

export interface HostPlayingScoreStripProps {
  hostIsPlaying: boolean;
  players: PlayerRow[];
  myPlayerId: string;
  pointsThisQuestion?: number | null;
  showQuestionPointsLine?: boolean;
}

export const HostPlayingScoreStrip: React.FC<HostPlayingScoreStripProps> = ({
  hostIsPlaying,
  players,
  myPlayerId,
  pointsThisQuestion = null,
  showQuestionPointsLine = false,
}) => {
  const { t } = useTranslation();

  if (!hostIsPlaying || !players?.length || !myPlayerId) {
    return null;
  }

  const sorted = [...players].sort((a, b) => b.score - a.score);
  const rank = sorted.findIndex((p) => p.id === myPlayerId) + 1;
  const me = sorted.find((p) => p.id === myPlayerId);
  if (!me || rank < 1) {
    return null;
  }

  const showPtsLine = showQuestionPointsLine && pointsThisQuestion !== null && pointsThisQuestion !== undefined;

  return (
    <div
      className="host-playing-score-strip"
      style={{
        width: '100%',
        marginBottom: '0.75rem',
        padding: '0.5rem 0.75rem',
        borderRadius: '10px',
        backgroundColor: 'rgba(255, 255, 255, 0.88)',
        border: '1.5px solid rgba(var(--color-primary-rgb), 0.25)',
        display: 'flex',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '0.5rem 1rem',
        fontSize: '0.85rem',
        color: 'var(--text-primary)',
        boxSizing: 'border-box',
        boxShadow: 'var(--shadow-sm)',
      }}
    >
      <span style={{ fontWeight: 700, color: 'var(--color-primary)' }}>
        {t('gameplay.hostScoreStrip.rankOf', { rank, total: players.length })}
      </span>
      <span style={{ opacity: 0.85 }}>{t('gameplay.hostScoreStrip.ptsTotal', { score: me.score })}</span>
      {showPtsLine && (
        <span style={{ fontWeight: 600, color: '#34D399' }}>
          {t('gameplay.hostScoreStrip.thisQuestion', { points: pointsThisQuestion })}
        </span>
      )}
    </div>
  );
};
